/*
 * @Author: Teemo Ding
 * @Date: 2021-07-15 15:50:23
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-26 15:07:28
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Payment/PaymentEditPage/config.tsx
 */
import { EnumMode } from '@/src/components/Antd/NumberInput/NumberInput';
import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import { QuestionCircleFilled } from '@ant-design/icons';
import { get } from 'lodash';
import React, { Fragment } from 'react';
import {
  //TableSelect,
  TableNumberInput,
} from 'src/components/EditableTable/TableForm/TableForm';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
  TooltipTitle,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
import css from './css.module.less';
// import {
//   TableNumberInput as TableNumberInput1,
//   Wrapper,
// } from 'src/components/EditableTable/TableForm1';
import FormNumberInput from '../Components/FormNumberInput';

export const breadcrumbData = (name, { getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '/settings/payment/list',
    name: getI18n('storePayment.paymentListPage.payment'),
  },
  {
    url: '',
    name: name || getI18n('storePayment.paymentListPage.addPaymentGateway'),
  },
];

export enum dynamicSuffixValues {
  OrderNumber = 'OrderNumber',
  OrderID = 'OrderID',
  NoSuffix = 'NoSuffix',
}

export const dynamicSuffixOptions = ({ getI18n }) => [
  {
    value: dynamicSuffixValues.OrderNumber,
    label: getI18n('storePayment.paymentEditPage.orderNumbereg1001'),
  },
  {
    value: dynamicSuffixValues.OrderID,
    label: getI18n('storePayment.paymentEditPage.orderIDegorder1001ABC'),
  },
  {
    value: dynamicSuffixValues.NoSuffix,
    label: getI18n('storePayment.paymentEditPage.nosuffix'),
  },
];

export const limitationColumns = (
  { amountOnChange },
  { getI18n, isEditable },
) => [
  {
    title: getI18n('general.currency'),
    dataIndex: 'currencyCode',
    default: true,
    minWidth: 320,
  },
  {
    title: getI18n('storePayment.paymentEditPage.minimumPaymentAmount'),
    default: true,
    minWidth: 320,
    children: [
      {
        title: (
          <div>
            <EditIcon />
            <span>{getI18n('storePayment.paymentEditPage.minimumAmount')}</span>
          </div>
        ),
        dataIndex: 'minAmount',
        default: true,
        width: 160,
        render: (text, record) => {
          const editable = isEditable?.(record.currencyCode);
          return editable ? (
            <div>
              <TableNumberInput
                mode={EnumMode.money}
                // error={priceError}
                rightPosition
                value={text}
                max={record.maxAmount}
                valueSuffix={` ${record.currencyCode}`}
                suffix={record.currencyCode}
                onChange={(e) => {
                  amountOnChange(record.currencyCode, { minAmount: e });
                }}
              />
              {/* <div>{record.currencyCode}</div> */}
            </div>
          ) : (
            <span>{`${text} ${record.currencyCode}`}</span>
          );
        },
      },
      {
        title: (
          <div className={css.title}>
            {getI18n('storePayment.paymentEditPage.referenceAmount')}{' '}
            <WhiteBackgroundTooltip
              title={
                <TooltipContainer>
                  <TooltipTitle>
                    {getI18n(
                      'storePayment.paymentEditPage.referenceMinimumPaymentAmount',
                    )}
                  </TooltipTitle>
                  <TooltipContent>
                    {getI18n(
                      'storePayment.paymentEditPage.referenceMinimumPaymentAmountContent',
                    )}
                  </TooltipContent>
                </TooltipContainer>
              }
              placement='rightTop' //overlayClassName
            >
              <QuestionCircleFilled className={css.icon} />
            </WhiteBackgroundTooltip>
          </div>
        ),
        width: 160,
        dataIndex: 'minReferenceAmount',
        default: true,
        render: (text, record) => `${text} ${record.currencyCode}`,
      },
    ],
  },
  {
    title: getI18n('storePayment.paymentEditPage.maximumPaymentAmount'),
    default: true,
    minWidth: 320,
    children: [
      {
        title: (
          <div>
            <EditIcon />
            <span>{getI18n('storePayment.paymentEditPage.maximumAmount')}</span>
          </div>
        ),
        dataIndex: 'maxAmount',
        default: true,
        width: 160,
        render: (text, record) => {
          const editable = isEditable?.(record.currencyCode);
          return editable ? (
            <TableNumberInput
              mode={EnumMode.money}
              // error={priceError}
              rightPosition
              value={text}
              min={record.minAmount}
              valueSuffix={` ${record.currencyCode}`}
              suffix={record.currencyCode}
              onChange={(e) => {
                amountOnChange(record.currencyCode, { maxAmount: e });
              }}
            />
          ) : (
            <span>{`${text} ${record.currencyCode}`}</span>
          );
        },
      },
      {
        title: (
          <div className={css.title}>
            {getI18n('storePayment.paymentEditPage.referenceAmount')}{' '}
            <WhiteBackgroundTooltip
              title={
                <TooltipContainer>
                  <TooltipTitle>
                    {getI18n(
                      'storePayment.paymentEditPage.referenceMaximumPaymentAmount',
                    )}
                  </TooltipTitle>
                  <TooltipContent>
                    {getI18n(
                      'storePayment.paymentEditPage.referenceMaximumPaymentAmountContent',
                    )}
                  </TooltipContent>
                </TooltipContainer>
              }
              placement='rightTop' //overlayClassName
            >
              <QuestionCircleFilled className={css.icon} />
            </WhiteBackgroundTooltip>
          </div>
        ),
        dataIndex: 'maxReferenceAmount',
        default: true,
        width: 160,
        render: (text, record) => `${text} ${record.currencyCode}`,
      },
    ],
  },
];

export const methodsColumns = (
  processingFeeChange,
  { getI18n },
  hasFPSQRCode,
) => {
  const columns = [
    {
      title: getI18n('storePayment.paymentEditPage.paymentMethods'),
      dataIndex: 'paymentMethod',
      key: 'paymentMethod',
      default: true,
      minWidth: 320,
      render: (text) => (
        <div>
          {text.name}
          {text?.icons?.length > 0 &&
            text.icons.map((icon, index) => (
              <img
                style={{ height: 20, marginLeft: 8 }}
                key={`${index}-${text.uuid}`}
                src={icon.url}
              />
            ))}
        </div>
      ),
    },
    {
      title: getI18n('storePayment.paymentEditPage.usedinSalesChannels'),
      dataIndex: 'salesChannelSummaries',
      key: 'salesChannelSummaries',
      default: true,
      minWidth: 400,
      render: (text) =>
        (text || []).length
          ? text.map((summary, index) => (
              <div key={index}>
                <div>{summary.salesChannelName}</div>
                <div className={css.channelType}>{summary.channelType}</div>
              </div>
            ))
          : getI18n('storePayment.paymentEditPage.notusedinanysaleschannel'),
    },
  ];

  if (!hasFPSQRCode) {
    columns.splice(1, 0, {
      title: (
        <div>
          <EditIcon />
          <span>{getI18n('storePayment.paymentEditPage.processingfee')}</span>
        </div>
      ),
      dataIndex: 'processingFee',
      key: 'processingFee',
      default: true,
      width: 360,
      render: (text, record, index) => (
        <Fragment>
          <FormNumberInput
            value={get(text, 'percent', 0)}
            onChange={(e) => {
              processingFeeChange(get(record, 'paymentMethod.uuid', ''), {
                processingFee: {
                  paymentMethodUuid: get(record, 'paymentMethod.uuid', ''),
                  percent: e,
                },
              });
            }}
          />
        </Fragment>
      ),
    });
  }

  return columns;
};
